import { render, staticRenderFns } from "./CompleteProfilAlert.vue?vue&type=template&id=460a23af"
import script from "./CompleteProfilAlert.vue?vue&type=script&lang=js"
export * from "./CompleteProfilAlert.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports